// extracted by mini-css-extract-plugin
export default {"container":"powerBankSharing_container__pSNAY"};